import React from 'react';
import cssClasses from './transaction.css';

const TransacionDetails = (props) => {
    const { TransactionDate, Description, Amount, TransactionType } = props.transDetails;

    return (
        <div>
            <div className={cssClasses.heading}>{props.modalName}</div>
            <div className={cssClasses.newFlexContainer}>
                <div className={cssClasses.newFlexItem}>Date: <span className={cssClasses.newTextGrey}>{TransactionDate && TransactionDate.toLowerCase()}</span></div>
                <div className={cssClasses.newFlexItem}>{(Amount > 0) ? 'Money in' : 'Money out'}:<span className={cssClasses.newTextGrey}> ${Math.abs(Amount).toFixed(2)}</span></div>
                <div className={cssClasses.newFlexItem}>Type:<span className={cssClasses.newTextGrey}>{TransactionType}</span></div>
                <div className={cssClasses.newFlexItem3}>Description: <span className={cssClasses.newTextGrey}>{Description && Description.toLowerCase()}</span></div>
            </div>
        </div>
     );
}

export default TransacionDetails;


// WEBPACK FOOTER //
// ./src/components/Transaction/TransactionDetails.js